<div
  [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme"
  (mouseover)="sidebarHoverMouseIn()"
  (mouseout)="sidebarHoverMouseOut()"
>
  <div class="app-header__logo">
    <div class="logo-src"></div>
   <div class="header__pane ml-auto">
      <button
        type="button"
        class="hamburger close-sidebar-btn hamburger--elastic"
        [ngClass]="{ 'is-active': globals.toggleSidebar }"
        (click)="toggleSidebar()"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-sidebar-content">
    <div class="app-sidebar-scroll">
      <perfect-scrollbar
        [autoPropagation]="true"
        class="scroll-container"
        [config]="config"
        [scrollIndicators]="true"
        style="max-width: 600px; max-height: 800px"
      >
        <div class="v-sidebar-menu vsm-default m-2">
          <div *ngIf="hasRole('admin')" class="vsm-list">
            <div class="vsm-item">
              <a
                routerLink="app/pages/dashboard"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon  las la-home"></i>
                <span class="vsm-title">Dashboard</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/fxTrend" class="vsm-link">
                <i class="vsm-icon las pe-7s-graph2"></i>
                <span class="vsm-title">Fx Trend</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="app/pages/config/regular-updates"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-cloud"></i>
                <span class="vsm-title">Regular Updates</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/config/events"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-box1"></i>
                <span class="vsm-title">Events</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/config/news-updates"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">News Updates</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/calculator" class="vsm-link">
                <i class="vsm-icon pe-7s-display1"></i>
                <span class="vsm-title">Calculator</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="app/pages/transactions/list"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">Transaction List</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/transactions/sd-list"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">Advise Request List</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/premium-rate-update"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">Update Premium Rate</span>
              </a>
            </div>

            <div class="vsm-item">
              <a routerLink="app/pages/customer/bulkFrd" class="vsm-link">
                <i class="vsm-icon las la-calculator"></i>
                <span class="vsm-title">Bulk Forwards</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/mtm" class="vsm-link">
                <i class="vsm-icon las la-calculator"></i>
                <span class="vsm-title">MTM</span>
              </a>
            </div>

            <div class="vsm-item">
              <a routerLink="app/pages/customer/cashflow" class="vsm-link">
                <i class="vsm-icon las la-clipboard-list"></i>
                <span class="vsm-title">Payables / Receivables</span>
              </a>
            </div>
            <div class="vsm-item">
              <a
                routerLink="app/pages/payment/intiate"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-credit"></i>
                <span class="vsm-title">Payment demo</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/config/select-plan"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-note2"></i>
                <span class="vsm-title">Select Plan</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/websocketTest" class="vsm-link">
                <i class="vsm-icon las la-user"></i>
                <span class="vsm-title">Live Rate</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/frdList" class="vsm-link">
                <i class="vsm-icon pe-7s-users"></i>
                <span class="vsm-title">Forward Rate List</span>
              </a>
            </div>
            <ngb-accordion
              [destroyOnHide]="false"
              [closeOthers]="true"
              #acc="ngbAccordion"
              activeIds="{{ extraParameter }}"
            >
              <!-- <ngb-panel>
                <ng-template ngbPanelHeader>
                  <div class="vsm-header">Admin</div>
                </ng-template>
              </ngb-panel> -->

              <ngb-panel id="dashboards">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-user"></i>
                    <span class="vsm-title">Users</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <!-- <i class="vsm-icon pe-7s-user" style="left: 20px;top: 25%;"></i> -->
                        <a
                          routerLink="app/pages/users/users"
                          routerLinkActive="active-item"
                          [routerLinkActiveOptions]="{ exact: true }"
                          class="vsm-link"
                        >
                          <span class="vsm-title"> Users</span>
                        </a>
                      </div>
                      <div class="vsm-item">
                        <!-- <i class="vsm-icon  pe-7s-user" style="left: 20px;top: 52%;"></i> -->
                        <a
                          routerLink="app/pages/users/partners"
                          routerLinkActive="active-item"
                          [routerLinkActiveOptions]="{ exact: true }"
                          class="vsm-link"
                        >
                          <span class="vsm-title">Partners</span>
                        </a>
                      </div>
                      <div class="vsm-item">
                        <!-- <i class="vsm-icon pe-7s-user" style="left: 20px;top: 78%;"></i> -->
                        <a
                          routerLink="app/pages/users/clients"
                          routerLinkActive="active-item"
                          [routerLinkActiveOptions]="{ exact: true }"
                          class="vsm-link"
                        >
                          <span class="vsm-title">Clients</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>

            <!-- <div class="vsm-item">
              <a routerLink="app/pages/users" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">Users</span>
              </a>
            </div> -->

            <!-- <div class="vsm-item">
              <a routerLink="/charts/chartjs" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-graph2"></i>
                <span class="vsm-title">ChartJS</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="/charts/apexcharts" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-graph"></i>
                <span class="vsm-title">Apex Charts</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="/charts/gauges" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-gleam"></i>
                <span class="vsm-title">Gauges</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="/charts/sparklines" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-graph1"></i>
                <span class="vsm-title">Chart Sparklines</span>
              </a>
            </div> -->
          </div>

          <div *ngIf="hasRole('client') || hasRole('subuser')  " class="vsm-list">
            <div class="vsm-item">
              <a
                routerLink="app/pages/customer/dashboard"
                routerLinkActive="active-item"
                class="vsm-link"
              ><i class="vsm-icon las la-home"></i>
                <span class="vsm-title">Dashboard</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/fxTrend" class="vsm-link">
                <i class="vsm-icon las pe-7s-graph2"></i>
                <span class="vsm-title">Fx Trend</span>
              </a>
            </div>
            <div class="vsm-item">
              <!-- <a routerLink="app/pages/customer/calculator" class="vsm-link">
                <i class="vsm-icon pe-7s-display1"></i>
                Calculator </a> -->
              <a routerLink="app/pages/customer/calculator" class="vsm-link">
                <i class="vsm-icon las fa-calculator"></i>
                <span class="vsm-title">FX Margin Calculators</span>
              </a>
            </div>


            <div class="vsm-item">
              <a routerLink="app/pages/customer/bulkFrd" class="vsm-link">
                <i class="vsm-icon las la-calculator"></i>
                <span class="vsm-title">Bulk Forwards</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/mtm" class="vsm-link">
                <i class="vsm-icon las la-calculator"></i>
                <span class="vsm-title">MTM</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/transactions/list" class="vsm-link">
                <i class="vsm-icon las la-clipboard-list"></i>
                <span class="vsm-title">Transaction List</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/cashflow" class="vsm-link">
                <i class="vsm-icon pe-7s-cash"></i>
                <span class="vsm-title">Payables / Receivables</span>
              </a>
            </div>
            <div class="vsm-item">
              <a routerLink="app/pages/customer/eventsCalendar" class="vsm-link">
                <i class="vsm-icon fa fa-calendar"></i>
                <span class="vsm-title">Events Calendar</span>
              </a>
            </div>
            <!-- <div class="vsm-item">
              <a routerLink="app/pages/customer/websocketTest" class="vsm-link">
                <i class="vsm-icon pe-7s-magic-wand"></i>
                <span class="vsm-title">Live Rate</span>
              </a>
            </div>

            <div class="vsm-item">
              <a routerLink="app/pages/customer/plans" class="vsm-link">
                <i class="vsm-icon pe-7s-shopbag"></i>
                <span class="vsm-title">Plan</span>
              </a>
            </div> -->

            <div class="vsm-item" *ngIf="hasRole('client') ">
              <a routerLink="app/pages/customer/profile" class="vsm-link">
                <i class="vsm-icon las la-user-circle"></i>
                <span class="vsm-title">Profile</span>
              </a>
            </div>
            <div class="vsm-item"  *ngIf="hasRole('client') ">
              <a routerLink="app/pages/customer/subuser" class="vsm-link">
                <i class="vsm-icon pe-7s-users"></i>
                <span class="vsm-title">Sub user List</span>
              </a>
            </div>





            <!-- <div class="vsm-item">
              <a routerLink="app/pages/config/regular-updates" class="vsm-link">
                <i class="vsm-icon pe-7s-display1"></i>
                <span class="vsm-title">updates</span>
              </a>
            </div>

            <div class="vsm-item">
              <a
                routerLink="app/pages/config/news-updates"
                routerLinkActive="active-item"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-id"></i>
                <span class="vsm-title">News Updates</span>
              </a>
            </div>

            <div class="vsm-item">
              <a routerLink="app/pages/config/events" class="vsm-link">
                <i class="vsm-icon pe-7s-display1"></i>
                <span class="vsm-title">Events</span>
              </a>
            </div> -->
            <!-- <div class="vsm-item">
              <a
                routerLink="app/pages/customer/upcoming-transactions"
                class="vsm-link"
              >
                <i class="vsm-icon pe-7s-display1"></i>
                <span class="vsm-title">Up Comming Transaction</span>
              </a>
            </div> -->
            <!-- <div class="vsm-item">
              <a routerLink="app/pages/customer/billings" class="vsm-link">
                <i class="vsm-icon pe-7s-display1"></i>
                <span class="vsm-title">Billings</span>
              </a>
            </div> -->
          </div>


        </div>

      </perfect-scrollbar>
      <div class="d-block text-center card-footer" >

        <a class="mailto mb-2 mr-2 btn-icon btn-pill btn btn-success" href="mailto:help@savedesk.co"><i class="lnr-hand btn-icon-wrapper"> </i>Help / Support</a>
</div>
    </div>
  </div>
</div>
